import {ErrorHandlerInterface} from './handlers/ErrorHandlerInterface';

export class BBErrors {

    private errorHandler: ErrorHandlerInterface;

    constructor(errorHandler: ErrorHandlerInterface) {
        this.errorHandler = errorHandler;
    }

    public watch(): void {
        let watchThis = this;
        window.onerror = (message: string, source?: string, fileno?: number, columnNumber?: number, error?: Error) => {
            watchThis.error(message, source, fileno, columnNumber, error);
        };
    }

    private error(message: string, source?: string, fileno?: number, columnNumber?: number, error?: Error): void {
        this.errorHandler.init(message, source, fileno, columnNumber, error);
    }

    public send(message: string): void {
        this.errorHandler.init(message);
    }

}